import { render } from "./CompanyGoals.vue?vue&type=template&id=02ee543a&scoped=true"
import script from "./CompanyGoals.vue?vue&type=script&lang=js"
export * from "./CompanyGoals.vue?vue&type=script&lang=js"

import "./CompanyGoals.vue?vue&type=style&index=0&id=02ee543a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aryav\\Desktop\\Don't touch this file\\Talreq\\talreq\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ee543a"]])

export default __exports__